function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import { nodeArray } from 'meteora';
import ToggleHeight from './toggle-height';

/*------------------------------------------------------------------
Accordion
------------------------------------------------------------------*/

// .js-accordion requires children with class .js-accordion--item, with a .js-accordion--trigger and .js-accordion--target element
var Accordion = /*#__PURE__*/_createClass(function Accordion(el) {
  var _this = this;
  _classCallCheck(this, Accordion);
  this.container = el;
  this.items = nodeArray(this.container.querySelectorAll('.js-accordion--item'));
  this.items.forEach(function (item) {
    // assign the target and trigger to the item's properties
    item.Accordion = {
      trigger: item.querySelector('.js-accordion--trigger'),
      target: item.querySelector('.js-accordion--target')
    };
  });
  this.items.forEach(function (item) {
    // this will be used to animated the height of the target
    item.control = new ToggleHeight(item.Accordion.target);

    // if the item has this class, the target will be open
    if (item.classList.contains('js-active')) item.control.animate('auto');
    item.Accordion.trigger.addEventListener('click', function (e) {
      e.preventDefault();

      // click event will either open or close the target, while toggling the js-active class
      _this.items.forEach(function (child) {
        if (child === item && child.classList.contains('js-active') || child !== item) {
          child.classList.remove('js-active');
          child.control.animate(0);
        } else {
          child.classList.add('js-active');
          child.control.animate('auto');
        }
      });
    });
  });
});
export default Accordion;